var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 24,
    viewBox: "0 0 121 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7341_35415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.064 0.111328H118.519V0.325898H117.909V1.99345H117.675V0.325898H117.064V0.111328Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.674 0.111328H118.969L119.637 1.67424L120.295 0.111328H120.586V1.99345H120.357V0.510004L119.733 1.99345H119.527L118.903 0.510004V1.99345H118.674V0.111328Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.543V0H2.30464V16.4238H10.755V18.543H0Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1094 5.03311H17.5465V3.52318C17.5465 1.13907 18.5531 0 21.0696 0H23.5332V1.98676H21.2021C20.116 1.98676 19.7186 2.43709 19.7186 3.4702V5.03311H23.5332V7.01987H19.7186V18.543H17.5465V7.01987H15.1094V5.03311Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3105 11.7879C23.3105 7.68197 25.9066 4.87402 29.7211 4.87402C33.5357 4.87402 36.0258 7.28462 36.1317 11.2846C36.1317 11.576 36.1052 11.8939 36.0788 12.2118H25.5887V12.3972C25.6682 14.9667 27.2841 16.7681 29.8536 16.7681C31.7609 16.7681 33.2443 15.7614 33.6947 14.0131H35.8933C35.3635 16.7151 33.1384 18.7018 30.0125 18.7018C25.9596 18.7018 23.3105 15.9204 23.3105 11.7879ZM33.8006 10.4104C33.5887 8.07932 31.9993 6.78131 29.7476 6.78131C27.7609 6.78131 25.9331 8.21177 25.7211 10.4104H33.8006Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5527 0H59.8825V2.11921H53.8706V18.543H51.566V2.11921H45.5527V0Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1014 10.7548V18.5429H82.9293V10.8873C82.9293 8.23826 81.7637 6.86078 79.724 6.86078C77.4723 6.86078 76.0948 8.55614 76.0948 11.3111V18.5429H73.9226V10.8873C73.9226 8.23826 72.7306 6.86078 70.6644 6.86078C68.4392 6.86078 67.0882 8.71508 67.0882 11.4171V18.5429H64.916V5.03296H66.7968L67.0882 6.88727C67.8034 5.90714 68.9425 4.87402 71.0352 4.87402C72.916 4.87402 74.5319 5.72171 75.3001 7.44356C76.1213 5.98661 77.5783 4.87402 79.9889 4.87402C82.7968 4.87402 85.1014 6.48992 85.1014 10.7548Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.394 11.0197V18.5429H100.222V11.1522C100.222 8.34422 98.9237 6.86078 96.5661 6.86078C94.0231 6.86078 92.4866 8.74157 92.4866 11.7879V18.5429H90.3145V5.03296H92.1952L92.4866 6.86078C93.2813 5.82767 94.6588 4.87402 96.937 4.87402C99.9833 4.87402 102.394 6.5429 102.394 11.0197Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.081 5.03296H116.962V17.8806C116.962 21.7747 114.896 23.9999 110.26 23.9999C106.816 23.9999 104.406 22.384 104.061 19.4171H106.287C106.657 21.1124 108.167 22.0661 110.419 22.0661C113.253 22.0661 114.79 20.7416 114.79 17.8012V16.2118C113.889 17.7482 112.432 18.7018 110.154 18.7018C106.419 18.7018 103.664 16.1853 103.664 11.7879C103.664 7.65548 106.419 4.87402 110.154 4.87402C112.432 4.87402 113.942 5.85416 114.79 7.36409L115.081 5.03296ZM114.816 11.8409C114.816 8.87402 113.015 6.8078 110.366 6.8078C107.717 6.8078 105.889 8.84753 105.889 11.7879C105.889 14.7283 107.691 16.7681 110.366 16.7681C113.042 16.7681 114.816 14.7283 114.816 11.8409Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7894 5.0332H86.6172V18.5431H88.7894V5.0332Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2759 1.57351C89.2759 2.44238 88.5713 3.14702 87.7024 3.14702C86.8335 3.14702 86.1289 2.44238 86.1289 1.57351C86.1289 0.704636 86.8322 0 87.7024 0C88.5726 0 89.2759 0.704636 89.2759 1.57351Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.471 5.0332H61.2988V18.5431H63.471V5.0332Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9595 1.57351C63.9595 2.44238 63.2549 3.14702 62.386 3.14702C61.5171 3.14702 60.8125 2.44238 60.8125 1.57351C60.8125 0.704636 61.5171 0 62.386 0C63.2549 0 63.9595 0.704636 63.9595 1.57351Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0101 5.0332H11.8379V18.5431H14.0101V5.0332Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4966 1.57351C14.4966 2.44238 13.792 3.14702 12.9231 3.14702C12.0542 3.14702 11.3496 2.44238 11.3496 1.57351C11.3496 0.704636 12.0529 0 12.9231 0C13.7933 0 14.4966 0.704636 14.4966 1.57351Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4126 6.61062C42.4126 7.47949 41.708 8.18413 40.8391 8.18413C39.9703 8.18413 39.2656 7.47949 39.2656 6.61062C39.2656 5.74175 39.9703 5.03711 40.8391 5.03711C41.708 5.03711 42.4126 5.74175 42.4126 6.61062Z",
    fill: "#FB7B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4126 17.1057C42.4126 17.9746 41.708 18.6792 40.8391 18.6792C39.9703 18.6792 39.2656 17.9746 39.2656 17.1057C39.2656 16.2369 39.9703 15.5322 40.8391 15.5322C41.708 15.5322 42.4126 16.2369 42.4126 17.1057Z",
    fill: "#FB7B34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7341_35415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.587,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogoDark);
export default __webpack_public_path__ + "static/media/login-logo-dark.a2bbe32dc1b07524d08b5b929e8e5097.svg";
export { ForwardRef as ReactComponent };